import React from 'react';
import AuthFooter from 'layout/auth/AuthFooter';
import BgImage from './../../assets/images/landingPage/bg1.jpg';

type PreLoginLayoutProps = {
  header: React.ReactNode;
  body: React.ReactNode;
};

const PreLoginLayout: React.FC<PreLoginLayoutProps> = ({ header, body }) => {
  return (
    <section className="bg-gray-300" style={{ backgroundImage: `url(${BgImage})` }}>
      <div className="min-h-screen flex flex-col items-center justify-center bg-blueGray-50">
        <div className="w-full lg:w-4/12 px-4 mx-auto">
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-slate-100 border-0">
            <div className="rounded-t mb-0 px-6 py-6">{header}</div>
            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">{body}</div>
          </div>
        </div>
        <AuthFooter />
      </div>
    </section>
  );
};

export default PreLoginLayout;
